export const UPDATE_BASKET = 'UPDATE_BASKET';
export const UPDATE_DELIVERY_POINT = 'UPDATE_DELIVERY_POINT';
export const UPDATE_DELIVERY_DATE_INDEX = 'UPDATE_DELIVERY_DATE_INDEX';
export const UPDATE_GROUPDELIVERY_DAY = 'UPDATE_GROUPDELIVERY_DAY';
export const UPDATE_PENDING_DELIVERY_POINT = 'UPDATE_PENDING_DELIVERY_POINT';
